import { ref, push } from "firebase/database";
import { db } from "../utils/firebase";
import axios from 'axios';


const sendData = async ({ age, gender, image,ifile }) => {
  const name = localStorage.getItem("username");
  const currentDate = new Date();
  const formattedDate = `${currentDate.getDate()}-${
    currentDate.getMonth() + 1
  }-${currentDate.getFullYear()}`;
  const data = {
    name: name,
    age: age,
    gender: gender,
    image: image,
    date: formattedDate,
    disease: "normal",
  };

  try {
    // const output = await query(image);
    const output = await query(ifile);
    // console.log(output);
    var detail = [false,output.score];
    if(output.result === "healthy"){
      detail[0] =true;
    }else{ 
      data['disease']="pneumonia";
      // var detail = [false,output.score];
    }
    await push(ref(db, "xray_data"), data);

    // const detail = [false,97.5]

     return detail
  } catch (error) {
    console.error("Error adding data: ", error);
    return null;
  }
};

async function query(filename){
  const formData = new FormData();
  formData.append('file', filename);
  try {
    // https://bashbuster-chexapi.hf.space
    const response = await axios.post('https://bashbuster-chexapi.hf.space/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // console.log(response.data);
      return response.data
    
  } catch (error) {
    console.error('Error uploading file: ', error);
  }
}


export { sendData };
